import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import TimePicker from 'material-ui/TimePicker'
import Button from 'material-ui/FlatButton'

class CreateOrCancelAllDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      time: null
    }
    this.updateTime = this.updateTime.bind(this)
    this.submit = this.submit.bind(this)
  }
  updateTime(e, time) {
    this.setState({ time })
  }

  submit(time) {
    const { isCreationOperation, onCreate, onCloseAll } = this.props
    if (isCreationOperation) onCreate(time)
    else onCloseAll()
  }

  render() {
    const { time } = this.state
    const { isOpen, isCreationOperation, day, onCancel } = this.props
    return (
      <Dialog
        title={isCreationOperation ? 'Criar Novo Horário' : 'Fechar Todos Horários'}
        open={isOpen}
        modal={false}
        contentStyle={{ maxWidth: 320 }}
        actions={[
          <Button label="Não" secondary onClick={onCancel} />,
          <Button label="Sim" primary onClick={this.submit.bind(null, time)} />
        ]}
        onRequestClose={onCancel}>

        {!isCreationOperation ? `Tem certeza que quer fechar todos os horários do dia ${day ? day.date : ''}?` : null}

        {/* When creating, show time picker */}
        {isCreationOperation ?
          <TimePicker
            minutesStep={5} format="24hr" autoOk
            hintText="Escolha o horário da nova consulta"
            value={time}
            onChange={this.updateTime}
            />
          : null
        }

      </Dialog>
    )
  }
}

CreateOrCancelAllDialog.propTypes = {
  isOpen: PropTypes.bool,
  isCreationOperation: PropTypes.bool,
  day: PropTypes.object,
  onCreate: PropTypes.func.isRequired,
  onCloseAll: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
export default CreateOrCancelAllDialog



// WEBPACK FOOTER //
// ./src/components/CreateOrCancelAllDialog/index.js